import LoginHistory from '@/app/login-history'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import Constants from '@/constants/Constants'
import { usersByRoleIdAndByCompanyIdQueryOptions } from '@/hooks/useUsersQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <LoginHistory />
}

export const Route = createFileRoute('/_auth/_withProject/login-history')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Giriş Geçmişi')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(
      usersByRoleIdAndByCompanyIdQueryOptions([Constants.Roles.OperasyonGorevlisi], companyId),
    )
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


